export const pageLanguageLinks = Object.freeze({
  "home": {
    "de": "/de",
    "fr": "/fr",
    "en": "/en"
  },
  "webform-route": {
    "de": {
      "name": "webform-route"
    },
    "fr": {
      "name": "webform-route"
    },
    "en": {
      "name": "webform-route"
    }
  },
  "events": {
    "de": "/de/die-aoz/wissensvermittlung/veranstaltungen",
    "fr": "/fr/die-aoz/wissensvermittlung/veranstaltungen",
    "en": "/en/die-aoz/wissensvermittlung/veranstaltungen"
  },
  "search": {
    "de": "/de/suche",
    "fr": "/fr/chercher",
    "en": "/en/search"
  },
  "node-canonical": {
    "de": {
      "name": "node-canonical"
    },
    "fr": {
      "name": "node-canonical"
    },
    "en": {
      "name": "node-canonical"
    }
  },
  "press-releases": {
    "de": "/de/medienmitteilung",
    "fr": "/fr/communiques-de-presse",
    "en": "/en/press-release"
  },
  "event-detail": {
    "de": {
      "name": "event-detail"
    },
    "fr": {
      "name": "event-detail"
    },
    "en": {
      "name": "event-detail"
    }
  },
  "webform-confirmation": {
    "de": {
      "name": "webform-confirmation"
    },
    "fr": {
      "name": "webform-confirmation"
    },
    "en": {
      "name": "webform-confirmation"
    }
  },
  "contact-slug": {
    "de": {
      "name": "contact-slug___de"
    },
    "fr": {
      "name": "contact-slug___fr"
    },
    "en": {
      "name": "contact-slug___en"
    }
  },
  "integration-programs": {
    "de": "/de/kurse-und-angebote",
    "fr": "/fr/programmes-dintegration",
    "en": "/en/integration-programs"
  },
  "blokkli-library-item-uuid": {
    "de": {
      "name": "blokkli-library-item-uuid"
    },
    "fr": {
      "name": "blokkli-library-item-uuid"
    },
    "en": {
      "name": "blokkli-library-item-uuid"
    }
  },
  "press-release-detail": {
    "de": {
      "name": "press-release-detail___de"
    },
    "fr": {
      "name": "press-release-detail___fr"
    },
    "en": {
      "name": "press-release-detail___en"
    }
  },
  "integration-programs-FilterButton": {
    "de": "/de/integration-programs/FilterButton",
    "fr": "/fr/integration-programs/FilterButton",
    "en": "/en/integration-programs/FilterButton"
  },
  "integration-programs-detail": {
    "de": {
      "name": "integration-programs-detail"
    },
    "fr": {
      "name": "integration-programs-detail"
    },
    "en": {
      "name": "integration-programs-detail"
    }
  }
});
export const routeNamesWithoutMapping = Object.freeze(["home","webform-route","events","drupal-route","node-canonical","event-detail","webform-confirmation","blokkli-library-item-uuid","integration-programs-FilterButton","integration-programs-detail"]);
export const routeNamesWithLanguageParam = Object.freeze(["home","webform-route","events","node-canonical","event-detail","webform-confirmation","blokkli-library-item-uuid","integration-programs-FilterButton","integration-programs-detail"]);